import { useEffect, useState } from 'react'

// Mobile breakpoint hook. Tracks (max-width: 767px) reactively so layouts
// can swap structure (e.g. inline sidebar ↔ overlay drawer) when the user
// resizes across the breakpoint. Mirrors the matchMedia pattern used in
// AppLayout's Phase-0 sidebar fix.
//
// SSR-safe: returns false on the server, then reads matchMedia on first
// client effect — page rendering is consistent.
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches
  )

  useEffect(() => {
    if (typeof window === 'undefined') return
    const mq = window.matchMedia('(max-width: 767px)')
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])

  return isMobile
}
